import styled from 'styled-components';
import theme from 'styles/theme';

export const Wrapper = styled.div`
  position: relative;

  .slick-list {
    margin: 0 -4px;
  }

  .slick-slide > div {
    padding: 0 4px;
  }

  .ant-carousel .slick-arrow {
    margin-top: -22px;
    z-index: 10;
    border: 1px solid ${theme.colors.neutralSilver5} !important;
    filter: drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.05));
  }

  .slick-disabled {
    display: none !important;
  }
`;

export const ArrowStyle = {
  background: theme.colors.globalWhite100,
  border: `1px solid ${theme.colors.neutralSilver5}`,
  width: '44px',
  height: '44px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};
